var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { KbService } from '@synisys/idm-kb-service-client-js';
import { ActionBuilder, FieldArg } from '../layout-actions';
var DynamicFormKbService = /** @class */ (function () {
    function DynamicFormKbService(kbService) {
        this.kbService = kbService;
    }
    DynamicFormKbService.prototype.getNameMetaFieldsSystemName = function (category) {
        return this.kbService.getNameMetaFieldIds(category).pipe(map(function (fields) {
            return fields.map(function (field) { return field.getSystemName(); });
        }));
    };
    DynamicFormKbService.prototype.getActions = function () {
        var _this = this;
        var result = [];
        result.push(new ActionBuilder()
            .name('nameMetaFields')
            .params([FieldArg('field-category')])
            .action(function (systemName) {
            return _this.getNameMetaFieldsSystemName(systemName);
        })
            .build());
        return result;
    };
    DynamicFormKbService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [KbService])
    ], DynamicFormKbService);
    return DynamicFormKbService;
}());
export { DynamicFormKbService };
//# sourceMappingURL=dynamic-form-kb.service.js.map